export const getMigrations = state => state.config.advanced.migrationConfig.migrations.data;
export const isLoadingMigrations = state => state.config.advanced.migrationConfig.migrations.loading;